
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import api from '../actions/api';

export const fetchServiceDashboardData = createAsyncThunk(
  'serviceDashboard/fetchServiceDashboardData',
  async (_, { rejectWithValue }) => {
    try {
      const res = await api({ auth: true }).get('/clinic/dashboard/services');
      return res.data.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data || 'Failed to fetch service dashboard data');
    }
  }
);

const serviceDashboardSlice = createSlice({
  name: 'serviceDashboard',
  initialState: {
    medical: 0,
    usednonmedical: {},
    revenuebyTop5: {},
    usedmedical: {},
    nonmedical: [],
    medicalCount: 0,
    nonmedicalCount: 0,
    top5ServicesByRevenue: {},
    loading: false,
    error: null,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchServiceDashboardData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchServiceDashboardData.fulfilled, (state, action) => {
        state.loading = false;

        state.medical = action.payload.medical || 0;
        state.usednonmedical = action.payload.usednonmedical || {};
        state.revenuebyTop5 = action.payload.revenuebyTop5 || {};
        state.usedmedical = action.payload.usedmedical || {};
        state.nonmedical = action.payload.nonmedical || [];
        state.medicalCount = action.payload.medicalCount || 0;
        state.nonmedicalCount = action.payload.nonmedicalCount || 0;
        state.top5ServicesByRevenue = action.payload.top5ServicesByRevenue || {};
      })
      .addCase(fetchServiceDashboardData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || 'Something went wrong';
      });
  },
});

export default serviceDashboardSlice.reducer;